import React from 'react'
import PropTypes from 'prop-types'

import Button from 'app/components/ButtonDefault'
import InfoBlock from 'app/components/InfoBlock'

import './styles.scss'
const bc = 'user-protrack-done-panel'

const UserProTrackSelectNew = ({ t, goToSelectProTrack, hasAbilityToSelectNewProTrack, organizationName }) => {
  if (!hasAbilityToSelectNewProTrack) {
    return (
      <InfoBlock>
        <div>
          {t('joining-your-team', { organizationName })} <br /> {t('we-will-let-you-know')}
        </div>
      </InfoBlock>
    )
  }

  return (
    <div className={bc}>
      <div className={`${bc}__title`}>{t(`journey`)}</div>
      <Button primary xs onClick={() => goToSelectProTrack()}>
        {t('Select New ProTrack')}
      </Button>
    </div>
  )
}

UserProTrackSelectNew.defaultProps = {
  hasAbilityToSelectNewProTrack: true,
}

UserProTrackSelectNew.propTypes = {
  organizationName: PropTypes.string.isRequired,
}

export default UserProTrackSelectNew
